import axios from 'axios';

export const validateTicketQRCode = async ({ headers, payload }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_ORDER_BASE_URL}/validate/qrcode`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};
